import store from "../../store"
import {LogoPoolStoreStatic} from "@k/js/logopoolInteractor";
import {ILogoPoolStore} from "@k/js/user";
import {LogoPoolEntry} from "@k/js/databaseInterfaceClasses";

export const LogoPoolStoreWrapper: ILogoPoolStore = {
    loadLogoPool() {return store.dispatch("loadLogoPool")},
    getLogoById(id: string): LogoPoolEntry | null {return store.getters.getLogoPoolEntryByID(id);},
    getLogoByTypeAndFilename(type, filename): LogoPoolEntry | null {return store.getters.getLogoPoolEntryByTypeAndID(type, filename)},
    getAddedLogos(logosToTest: LogoPoolEntry[]): LogoPoolEntry[] {return LogoPoolStoreStatic.getLogosNotInSecondArray(logosToTest, store.getters.getLogoPool);},
    getDeletedLogos(logosToTest: LogoPoolEntry[]): LogoPoolEntry[] {return LogoPoolStoreStatic.getLogosNotInSecondArray(store.getters.getLogoPool, logosToTest);},
    getLogoByFilename(filename): LogoPoolEntry | null {return store.getters.getLogoByFilename(filename);},
    getLogos(): LogoPoolEntry[] {return store.getters.getLogoPool;},
    logoPoolIsEmtpy(): boolean {return store.getters.getLogoPool.length === 0;},
    removeLogo(logoPoolEntry: LogoPoolEntry): void {store.commit("DELETE_LOGOS", [logoPoolEntry]);},
    removeLogosFromLogoPool(deletedLogos: LogoPoolEntry[]): void {store.commit("DELETE_LOGOS", deletedLogos)},
    removeStockLogo(logoPoolEntry: LogoPoolEntry): void {store.commit("DELETE_LOGOS", [logoPoolEntry])},
    setLogos(logos: LogoPoolEntry[]): void {store.commit("SETLOGOPOOL", logos);},
    addLogos(newLogos) {store.commit("ADD_LOGOS", newLogos);}
}
